<template>
  <div class="verification-form-documents">
    <div class="verification-form-documents__documents app-key-value__list">
      <div class="verification-form-documents__documents-wrp">
        <div class="verification-form-documents__header">
          <h3 class="verification-form-documents__title">
            {{ "verification-form-documents.title-docs-ticks" | globalize }}
          </h3>
          <tick-field
            class="app__form-field"
            v-model="checkAllTicks"
            :disabled="isDisabled"
          />
        </div>
        <div class="verification-form-documents__row app-key-value__row">
          <span class="app-key-value__key">
            {{ 'verification-form-documents.lbl-name' | globalize }}
          </span>
          <div class="verification-form-documents__wrp">
            <span class="app-key-value__value">
              {{ formatData(userDetails.validFullName) }}
            </span>
            <tick-field
              class="app__form-field"
              v-model="form.name"
              @input="former.setAttr('documents.name', form.name)"
              :disabled="isDisabled"
            />
          </div>
        </div>

        <div class="verification-form-documents__row app-key-value__row">
          <span class="app-key-value__key">
            {{ 'verification-form-documents.lbl-date-of-birth' | globalize }}
          </span>
          <div class="verification-form-documents__wrp">
            <span
              class="app-key-value__value">
              {{ formatData(userDetails.general.birthDate) }}
            </span>
            <tick-field
              class="app__form-field"
              :label="'verification-form-documents.lbl-date-of-birth'
                | globalize"
              v-model="form.birthDate"
              @input="former.setAttr('documents.birthDate',
                                     form.birthDate)"
              :disabled="isDisabled"
            />
          </div>
        </div>

        <div class="verification-form-documents__row app-key-value__row">
          <span class="app-key-value__key">
            {{ 'verification-form-documents.lbl-nationality' | globalize }}
          </span>
          <div class="verification-form-documents__wrp">
            <span class="app-key-value__value">
              {{ formatData(userDetails.address.nationalities) }}
            </span>
            <tick-field
              class="app__form-field"
              v-model="form.nationalities"
              @input="former.setAttr('documents.nationalities',
                                     form.nationalities)"
              :disabled="isDisabled"
            />
          </div>
        </div>

        <div class="verification-form-documents__row app-key-value__row">
          <span class="app-key-value__key">
            {{ 'verification-form-documents.lbl-address' | globalize }}
          </span>
          <div class="verification-form-documents__wrp">
            <span class="app-key-value__value">
              {{ formatData(userDetails.validAddress) }}
            </span>
            <tick-field
              class="app__form-field"
              v-model="form.address"
              @input="former.setAttr('documents.address',
                                     form.address)"
              :disabled="isDisabled"
            />
          </div>
        </div>

        <div class="verification-form-documents__row app-key-value__row">
          <span class="app-key-value__key">
            {{ 'verification-form-documents.lbl-email' | globalize }}
          </span>
          <div class="verification-form-documents__wrp">
            <span class="app-key-value__value">
              {{ formatData(userDetails.general.email) }}
            </span>
            <tick-field
              class="app__form-field"
              v-model="form.email"
              @input="former.setAttr('documents.email',
                                     form.email)"
              :disabled="isDisabled"
            />
          </div>
        </div>

        <div class="verification-form-documents__row app-key-value__row">
          <span class="app-key-value__key">
            {{ 'verification-form-documents.lbl-place-of-birth' | globalize }}
          </span>
          <div class="verification-form-documents__wrp">
            <template v-if="userDetails.address.placeOfBirth">
              <span
                v-if="userDetails.address.placeOfBirth.country &&
                  userDetails.address.placeOfBirth.locality"
                class="app-key-value__value"
              >
                {{ formatData(userDetails.address.placeOfBirth.country) }} /
                {{ formatData(userDetails.address.placeOfBirth.locality) }}
              </span>
              <span
                v-if="userDetails.address.placeOfBirth"
                class="app-key-value__value"
              >
                {{ formatData(userDetails.address.placeOfBirth) }}
              </span>
              <tick-field
                v-model="form.placeOfBirth"
                class="app__form-field"
                @input="former.setAttr('documents.placeOfBirth',
                                       form.placeOfBirth)"
                :disabled="isDisabled"
              />
            </template>
            <template v-else>
              <div class="verification-form-documents__data-adding-block">
                <!-- eslint-disable -->
                <input-field
                  v-model="newPlaceOfBirth"
                  class="verification-form-documents__birth-place-field app-list-filters__field"
                  :label="'verification-form-documents.lbl-place-of-birth' | globalize"
                  :disabled="formMixin.isDisabled"
                  @blur="touchField('newPlaceOfBirth')"
                  :error-message="getFieldErrorMessage('newPlaceOfBirth')"
                  @input="former.setAttr('newPlaceOfBirth',
                                         newPlaceOfBirth)"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="verification-form-documents__documents-info-wrp">
        <template v-if="userDetails.isNotEmptyDocumentsArray">
          <div class="verification-form-documents__documents-details-wrp">
            <expandable-docs mainHeader="Documents" :source="userDetails.documentsArray"/>
          </div>
        </template>
        <template v-if="!former._isDocumentImagesEmpty()">
          <div class="verification-form-documents__documents-imgs-wrp">
            <button
              v-ripple
              class="verification-form-documents__dropdown-btn"
              type="button"
              @click="isImagesDocsShown = !isImagesDocsShown"
            >
              <i
                class="mdi verification-form-documents__dropdown-btn-icon"
                :class="{
                  'mdi-chevron-right': !isImagesDocsShown,
                  'mdi-chevron-down': isImagesDocsShown
                }"
              />
              <h3 class="verification-form-documents__subtitle">
                {{ "verification-form-documents.lbl-docs-images" | globalize }}
              </h3>
            </button>
            <template v-if="isImagesDocsShown">
              <div class="verification-form-documents__img-wrp">
                <img
                  class="app__img-preview"
                  v-for="image in former.attrs.imagesData.documentImages"
                  :key="image"
                  :src="image"
                  @click="selectPhotoUrl(image)"
                >
              </div>
            </template>
          </div>
        </template>

        <template v-else-if="userDetails.isNotEmptyDocImages">
          <div class="verification-form-documents__documents-imgs-wrp">
            <button
              v-ripple
              class="verification-form-documents__dropdown-btn"
              type="button"
              @click="isImagesDocsShown = !isImagesDocsShown"
            >
              <i
                class="mdi verification-form-documents__dropdown-btn-icon"
                :class="{
                  'mdi-chevron-right': !isImagesDocsShown,
                  'mdi-chevron-down': isImagesDocsShown
                }"
              />
              <h3 class="verification-form-documents__subtitle">
                {{ "verification-form-documents.lbl-docs-images" | globalize }}
              </h3>
            </button>
            <template v-if="isImagesDocsShown">
              <div class="verification-form-documents__img-wrp">
                <img
                  class="app__img-preview"
                  v-for="image in userDetails.documents.documentImages"
                  :key="image"
                  :src="image"
                  @click="selectPhotoUrl(image)"
                >
              </div>
            </template>
          </div>
        </template>

        <template v-if="!former._isDocumentDetailsEmpty()">
          <div class="verification-form-documents__documents-details-wrp">
            <button
              v-ripple
              class="verification-form-documents__dropdown-btn"
              type="button"
              @click="isDocsDetailsShown = !isDocsDetailsShown"
            >
              <i
                class="mdi verification-form-documents__dropdown-btn-icon"
                :class="{
                  'mdi-chevron-right': !isDocsDetailsShown,
                  'mdi-chevron-down': isDocsDetailsShown
                }"
              />
              <h3 class="verification-form-documents__subtitle">
                {{ "verification-form-documents.lbl-docs-details" | globalize }}
              </h3>
            </button>
            <details-reader
              v-if="isDocsDetailsShown"
              class="verification-form-documents__documents-details"
              :details="former.attrs.imagesData.documentDetails" />
          </div>
        </template>
        <template v-else-if="userDetails.isNotEmptyDocInfo">
           <div class="verification-form-documents__documents-details-wrp">
            <button
              v-ripple
              class="verification-form-documents__dropdown-btn"
              type="button"
              @click="isDocsDetailsShown = !isDocsDetailsShown"
            >
              <i
                class="mdi verification-form-documents__dropdown-btn-icon"
                :class="{
                  'mdi-chevron-right': !isDocsDetailsShown,
                  'mdi-chevron-down': isDocsDetailsShown
                }"
              />
              <h3 class="verification-form-documents__subtitle">
                {{ "verification-form-documents.lbl-docs-details" | globalize }}
              </h3>
            </button>
            <details-reader
              v-if="isDocsDetailsShown"
              class="verification-form-documents__documents-details"
              :details="userDetails.documentsInfo.documentDetails" />
          </div>
        </template>
      </div>
    </div>

    <photo-viewer
      v-if="selectedPhotoUrl"
      :img-url="selectedPhotoUrl"
      :is-shown.sync="isImageViewerShown"
    />
  </div>
</template>

<script>
import PhotoViewer from '@/vue/common/PhotoViewer'
import DetailsReader from '@/vue/common/DetailsReader/DetailsReader'
import ExpandableDocs from '@/vue/common/expandable-docs/list'
import { UserRecord } from '@/js/records/entities/user.record'
import { VerificationCDDFormer } from '@/js/formers/VerificationCDDFormer'
import { formatDateDMY } from '@/vue/filters/formatDateDMY'
import { validateDate, requiredIf } from '@validators'

import FormMixin from '@/vue/mixins/form.mixin'
import InputField from '@/vue/fields/InputField.vue'

export default {
  name: 'verification-form-documents',
  components: {
    PhotoViewer,
    DetailsReader,
    InputField,
    ExpandableDocs,
  },
  mixins: [ FormMixin ],
  props: {
    former: {
      type: VerificationCDDFormer,
      required: true,
    },
    userDetails: {
      type: UserRecord,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      form: {
        name: this.former.attrs.documents.name,
        placeOfBirth: this.former.attrs.documents.placeOfBirth,
        birthDate: this.former.attrs.documents.birthDate,
        nationalities: this.former.attrs.documents.nationalities,
        address: this.former.attrs.documents.address,
        email: this.former.attrs.documents.email,
      },
      isAllTicksChecked: false,
      selectedPhotoUrl: '',
      isImageViewerShown: false,
      isDocsDetailsShown: false,
      isImagesDocsShown: false,
      newPlaceOfBirth: '',
    }
  },
  validations () {
    return {
      newPlaceOfBirth: {
        required: requiredIf(function () {
          return !this.former.attrs.documents.placeOfBirth
        }),
      },
    }
  },

  computed: {
    checkAllTicks: {
      get: function () {
        return this.isAllTicksChecked
      },
      set: function (value) {
        Object.keys(this.form).forEach(key => {
          this.former.setAttr(`documents.${key}`, value)
          this.form[key] = value
        })
      },
    },
  },

  watch: {
    form: {
      handler (obj) {
        // Handle tick fields values, to toggle checkAllTick
        this.isAllTicksChecked = Object.values(obj).every(value => value)
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    isArray (value) {
      return Array.isArray(value)
    },
    isDate (value) {
      return validateDate(value)
    },
    formatData (value) {
      if (!value) {
        return '-'
      } else if (this.isArray(value)) {
        return value.join(', ')
      } else if (this.isDate(value)) {
        return formatDateDMY(value)
      } else {
        return value
      }
    },
    selectPhotoUrl (url) {
      this.selectedPhotoUrl = url
      this.isImageViewerShown = true
    },
  },
}
</script>
